import { napCimke, oszlopAdatok, tengelyCimkek, type NapiAdat } from './oszlopdiagram.ts';

export interface OszlopdiagramProps {
  /** Napi adatok növekvő sorrendben (nullás napokkal együtt). */
  napi: readonly NapiAdat[];
  /** A diagram akadálymentes neve (a táblázat-alternatíva felirata is). */
  nev: string;
}

/** Napi halmozott oszlopok (megerősített és nem megerősített), tengelyfeliratokkal és rejtett táblázat-alternatívával. */
export default function Oszlopdiagram({ napi, nev }: OszlopdiagramProps) {
  const adatok = oszlopAdatok(napi);
  const cimkek = tengelyCimkek(napi);
  return (
    <figure className="mt-5">
      <div role="img" aria-label={nev} className="flex h-37.5 items-end gap-[5px] border-b border-vonal">
        {adatok.map((o) => (
          <div key={o.nap} title={`${napCimke(o.nap)}: ${o.megerositett} megerősített, ${o.nem_megerositett} nem megerősített`} className="flex h-full flex-1 flex-col-reverse gap-0.5">
            <i className="block rounded-t-[3px] bg-kiemelt" style={{ height: `${o.megerositettSzazalek}%` }} />
            {o.nemSzazalek > 0 && <i className="block rounded-[3px] bg-felulet-lista" style={{ height: `${o.nemSzazalek}%` }} />}
          </div>
        ))}
      </div>
      <div aria-hidden className="mt-2 flex justify-between text-xs text-szoveg-halk">{cimkek.map((c) => <span key={c}>{c}</span>)}</div>
      <div className="mt-3 flex gap-4 text-xs text-szoveg-halk">
        <span className="flex items-center gap-1.5"><i className="size-2 rounded-[2px] bg-kiemelt" />Megerősített</span>
        <span className="flex items-center gap-1.5"><i className="size-2 rounded-[2px] bg-felulet-lista" />Nem megerősített</span>
      </div>
      <table className="sr-only">
        <caption>{nev}</caption>
        <thead><tr><th scope="col">Nap</th><th scope="col">Megerősített</th><th scope="col">Nem megerősített</th></tr></thead>
        <tbody>{adatok.map((o) => <tr key={o.nap}><th scope="row">{napCimke(o.nap)}</th><td>{o.megerositett}</td><td>{o.nem_megerositett}</td></tr>)}</tbody>
      </table>
    </figure>
  );
}
